import AXIOS from "./axios";

export class Slot {
  static create({ slot_config }) {
    return AXIOS.post("admin/slots/", { slot_config });
  }

  static delete(query) {
    return AXIOS.delete(`admin/slots${query ? "?" + query : ""}`);
  }

  static getConfig(query) {
    return AXIOS.get(`admin/slots${query ? "?" + query : ""}`);
  }

  static getDoctors() {
    return AXIOS.get("admin/slots/doctors");
  }

  static getUnits() {
    return AXIOS.get("admin/slots/units");
  }

  static simpleCreate(slot_config) {
    return AXIOS.post("admin/slots/simple_create", {
      slot_config: slot_config
    });
  }

  static timeSuggestion(suggestion) {
    return AXIOS.post("time_suggestions", suggestion);
  }
}
